import { FormContact } from './FormContact'

export default FormContact
